import React, { useEffect } from 'react';
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

// for all page of dashboard
import WebNav from '../components/WebNav';
import Sidebar from '../components/Sidebar';
import '../styles/Style.css';

const PricingPage = () => {

  const navigate = useNavigate();

  useEffect(() => {
        document.body.classList.add('loged-body');  
        return () => {
          document.body.classList.remove('loged-body');
        };
  }, []);

  const handlePayment = async (planId) => {
    navigate(`/subscribe?plan=${planId}`);
  };

  const plans = [
    {
      id: 1,
      type: "Club Administrator",
      create: "Create 25 dynamic page",
      price: 25,
      pages: 25,
      features: "Annual Plan",
    },
    {
      id: 2,
      type: "Club Administrator",
      create: "Create 50 dynamic page",
      price: 50,
      pages: 50,
      features: "Annual Plan",
    },
    {
      id: 3,
      type: "Club Administrator",
      create: "Create 100 dynamic page",
      price: 100,
      pages: 100,
      features: "Annual Plan",
    },
    {
      id: 4,
      type: "Single Contact Page",
      create: "Create 1 dynamic contact page",
      price: 1,
      pages: 1,
      features: "Annual Plan",
    },
  ];

  return (
    <>
      <Sidebar />
      <WebNav />
      <div className="d-body login-body">
        <Container className="mt-5">
            <Row className="justify-content-center">
            {plans.map((plan, index) => (
                <Col key={index} md={6} lg={4} className="mb-4">
                <Card className="shadow-lg" style={{ borderRadius: "10px" }}>
                    <Card.Header
                    className="text-center text-white"
                    style={{
                        backgroundColor: "#1A73E8",
                        fontSize: "1.5rem",
                        fontWeight: "bold",
                    }}
                    >
                    {plan.type}
                    </Card.Header>
                    <Card.Body className="text-center">
                    <h5 className="mb-3 text-primary">{plan.create}</h5>
                    <h3
                        className="text-success"
                        style={{
                        fontSize: "2rem",
                        fontWeight: "bold",
                        }}
                    >
                        €{plan.price} / year
                    </h3>
                    <h6 className="text-muted">{plan.features}</h6>
                    <hr />
                    <ul style={{ textAlign: "justify", lineHeight: "40px" }}>
                        <li> {plan.create}</li>
                        <li> Unlimited scans</li>
                        <li> Multiple downloads</li>
                        <li> Activate/deactivate anytime</li>
                        <li> Delete anytime</li>
                    </ul>
                    <Button
                        variant="primary"
                        className="mt-3"
                        onClick={() => handlePayment(plan.id)}
                        style={{
                        borderRadius: "5px",
                        padding: "10px 20px",
                        fontWeight: "bold",
                        }}
                    >
                        Subscribe
                    </Button>
                    </Card.Body>
                </Card>
                </Col>
            ))}
            </Row>
        </Container>
      </div>
    </>
  );
};

export default PricingPage;
